import {http} from './../helpers/http-helper';
import {Receipt} from './../classes/receipt';
import {ReceiptMemento} from './../classes/receipt-memento';

function createReceiptFromResponse(response) {
    return new Receipt(
        response.uuid,
        response.consignment,
        response.member,
        new Date(response.createdAt),
        (!!response.issueDate ? new Date(response.issueDate) : null),
        response.amount,
        response.status,
        response.periodicity,
        response.type,
        response.code,
        response.memberCalled,
        (!!response.chargeFromDate ? new Date(response.chargeFromDate) : null),
        response.chargedBy,
        (!!response.chargedAt ? new Date(response.chargedAt) : null),
        response.receiptMemento,
        (!!response.bankReturnDocumentHeaderDate ? new Date(response.bankReturnDocumentHeaderDate) : null)
    );
}

function createReceiptMementoFromResponse(response) {
    return new ReceiptMemento(
        response.uuid,
        response.consignment,
        response.receipt,
        response.user,
        response.status,
        new Date(response.date),
        response.text
    );
}

export const createReceiptCustom = (receipt) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/custom';
        http.post(url, receipt)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getReceipts = (params) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts';
        http.get(url, params)
            .then((response) => {
                if (response.status === 200) {
                    let receipts = [];

                    response.data.receipts.forEach((receipt) => {
                        receipts.push(createReceiptFromResponse(receipt));
                    });

                    resolve({
                        receipts: receipts,
                        count: response.data.count
                    });
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getReceipt = (receiptId) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createReceiptFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getReceiptMementos = (receiptId) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId + '/mementos';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let mementos = [];

                    response.data.forEach((memento) => {
                        mementos.push(createReceiptMementoFromResponse(memento));
                    });

                    resolve(mementos);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteReceipt = (receiptId) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteReceipts = (receiptsIds) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/delete';
        http.post(url, {receiptsIds}, null, 'blob')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const printReceipts = (receiptsIds, expeditionDate) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/print';
        http.post(url, {expeditionDate, receiptsIds}, null, 'blob')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const printReceipt = (receiptId, expeditionDate) => {
    return printReceipts([receiptId], expeditionDate);
};

export const updateReceiptsFromSepa = (sepaFile) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/sepa';

        let formData = new FormData();
        formData.append('sepa', sepaFile);

        http.post(url, formData)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const chargeReceiptByBank = (receiptId, chargeDate, memberCalled) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId + '/charge-by-bank';
        http.post(url, {chargeDate, memberCalled})
            .then((response) => {
                if (response.status === 200) {
                    resolve(createReceiptFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};



export const changeReceiptReturned = (receiptId) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId + '/return';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createReceiptFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const payReceipt = (receiptId, chargedBy) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId + '/pay';
        http.post(url, {chargedBy})
            .then((response) => {
                if (response.status === 200) {
                    resolve(createReceiptFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const receiptToPendingStatus = (receiptId) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId + '/to-pending';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createReceiptFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const cancelReceipt = (receiptId) => {
    return new Promise((resolve, reject) => {
        const url = 'receipts/' + receiptId + '/cancel';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createReceiptFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
